
import { CanAccess } from "@refinedev/core";
import { DefaultTemplate } from "@components/templates/default";
import { ConfigProfessional } from "./professional";
import { ConfigUser } from "./user";
import { PRO_ROLES, USER_ROLES } from "access/definitions";

export const Config = () => {
    return <DefaultTemplate>
        <CanAccess resource="home" action="show" params={{ roles: PRO_ROLES }}>
            <ConfigProfessional />
        </CanAccess>
        <CanAccess resource="home" action="show" params={{ roles: USER_ROLES }}>
            <ConfigUser />
        </CanAccess>
    </DefaultTemplate>
}
